<template>
  <div :class="containerClass">
    <p
      :class="headerMessageClass"
    >
      {{ headerMessage }}
    </p>
    <div :class="$style.itemTableContainer">
      <ItemTable
        v-if="isAuthorized"
        ref="itemTable"
        bulkActionText="send activation email"
        :columns="getColumns"
        :emptyCollectionMessage="customEmptyCollectionMessage"
        :handleBulkAction="handleBulkAction"
        :hasSelectColumn="true"
        :inDetailsAsidePanel="true"
        :itemType="itemType"
        :selectionItemText="selectionItemText"
        :showBound="false"
        :showBulkAction="true"
        :showSearchForm="false"
      />
    </div>
  </div>
</template>
<script>
import {
  BodyComponentConsts,
  ItemTableConsts,
  ItemTypeConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import { notify } from 'client/util';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTableMethodsMixin from 'client/components/ItemTable/mixins/ItemTableMethodsMixin';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import SystemUserItemTableColumns from 'client/systemusers/SystemUserItemTable/SystemUserItemTableColumns';
import UserStateMixin from 'client/components/mixins/UserStateMixin';

const { columnTypes } = ItemTableConsts;

const workdayImportedUserCollection = StoreModuleMap[ItemTypeConsts.workdayImportedUser];
const workdayModel = StoreModelMap[ItemTypeConsts.workday];

export default {
  name: 'WorkdayImportedUserItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
    ItemTableMethodsMixin,
    ItemTablePropsMixin,
    UserStateMixin,
  ],

  props: {
    parentBulkActionHandler: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      itemType: ItemTypeConsts.workdayImportedUser,
    };
  },

  computed: {
    ...mapGetters(workdayImportedUserCollection, {
      getFirstAndLastName: 'getFirstAndLastName',
      selectedItems: 'getSelectedItems',
      totalCountOfAllItems: 'getTotalCountOfAllItems',
    }),

    ...mapGetters(workdayModel, [
      'isAuthorized',
    ]),

    containerClass() {
      return this.isAuthorized ? this.$style.container : '';
    },

    getColumns() {
      const iconColumn = SystemUserItemTableColumns.state;
      const nameColumn = SystemUserItemTableColumns.name;

      return [
        iconColumn,
        nameColumn,
        {
          classNames: {
            body: [columnTypes.emailColumn],
            heading: [columnTypes.emailColumn],
          },
          dataField: 'email',
          headingText: 'Email',
          sortBy: 'email',
        },
        {
          bodyComponent: 'FormattedDate',
          bodyComponentProps: {
            type: BodyComponentConsts.formattedDateTypes.workdayTimestampField,
          },
          headingText: 'Import Date',
          sortBy: 'created',
        },
      ];
    },

    headerMessage() {
      return this.isAuthorized ? this.authorizedHeader : this.deauthorizedHeader;
    },

    headerMessageClass() {
      return [
        this.$style.headerMessage,
        !this.isAuthorized ? this.$style.headerMessageDeauthorized : '',
        this.totalCountOfAllItems === 0 ? this.$style.headerMessageHidden : '',
      ];
    },
  },

  created() {
    this.authorizedHeader = 'The following pending users have been imported from Workday:';
    this.deauthorizedHeader = 'Enable Workday Integration to import Workday users to JumpCloud.';
    this.customEmptyCollectionMessage = 'No users imported from Workday are pending activation.\nTo perform a new import, go to Workday Import details tab.';
  },

  methods: {
    handleBulkAction() {
      SystemUserApi.sendEmail(this.selectedItems)
        .then(() => {
          notify('info', 'Activation emails sent to selected users.');
        })
        .catch(() => {
          notify(
            'error',
            'There was a problem sending activation emails to selected users.',
          );
        });

      // Inform parent that bulk action was invoked
      this.parentBulkActionHandler();
    },
  },
};
</script>
<style module>
.container {
  height: 100%;
}

.headerMessage {
  height: 20px;
  margin: 0 !important;
  text-align: center;
}

.headerMessageDeauthorized {
  height: auto;
  padding-top: 7.5rem;
  text-align: center;
}

.headerMessageHidden {
  display: none;
}

.itemTableContainer {
  height: calc(100% - 20px);
}
</style>
